import {
  AllocationRulePropertiesDto,
  AllocationRuleSummaryDto,
  CarrierVisitAllocationRuleDto,
  CarrierVisitDirection,
  CarrierVisitsApi,
  CarrierVisitsApiCarrierVisitsCreateCarrierVisitAllocationAndRulesRequest,
} from '@storage/app/api'

export class CarrierVisitsService {
  constructor(private readonly _carrierVisitsApi: CarrierVisitsApi) {}

  async getAllocationRules(
    carrierVisitId: number,
    direction?: CarrierVisitDirection,
  ): Promise<Array<CarrierVisitAllocationRuleDto>> {
    const { data: allocationRules } = await this._carrierVisitsApi.carrierVisitsGetAllocationRules({
      carrierVisitId,
      direction,
    })
    return allocationRules
  }

  async createCarrierVisitAllocationAndRules(
    carrierVisitsCreateCarrierVisitAllocationAndRulesRequest?: CarrierVisitsApiCarrierVisitsCreateCarrierVisitAllocationAndRulesRequest,
  ): Promise<void> {
    await this._carrierVisitsApi.carrierVisitsCreateCarrierVisitAllocationAndRules(
      carrierVisitsCreateCarrierVisitAllocationAndRulesRequest ?? {},
    )
  }

  async getAllocationSummary(
    allocationRulePropertiesDto?: Array<AllocationRulePropertiesDto>,
  ): Promise<Array<AllocationRuleSummaryDto>> {
    const { data: allocationRuleSummaries } = await this._carrierVisitsApi.carrierVisitsAllocationSummary({
      allocationRulePropertiesDto,
    })
    return allocationRuleSummaries
  }
}
